var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.048 7.768v-2.49c0-.946.571-1.145 1-1.145h2.571V0H7.095c-3.905 0-4.81 3.087-4.81 5.029v2.739H0V12h2.286v12h4.762V12h3.238l.38-4.232H7.049z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMSAyNCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik03LjA0OCA3Ljc2OHYtMi40OWMwLS45NDYuNTcxLTEuMTQ1IDEtMS4xNDVoMi41NzFWMEg3LjA5NWMtMy45MDUgMC00LjgxIDMuMDg3LTQuODEgNS4wMjl2Mi43MzlIMFYxMmgyLjI4NnYxMmg0Ljc2MlYxMmgzLjIzOGwuMzgtNC4yMzJINy4wNDl6Ii8+Cjwvc3ZnPgo=";
export { SvgLogoFacebook as ReactComponent };